import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-4 mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "bg-indigo-50 rounded-md p-2.5 text-sm leading-5 font-normal" }, [
  /*#__PURE__*/_createTextVNode(" Only marketing contacts can receive this email. If you haven't done it yet, "),
  /*#__PURE__*/_createElementVNode("u", null, "learn how to set contacts as marketing")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mt-1" }, " Send email to", -1)
const _hoisted_4 = { class: "ml-3" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { id: "overlaySelectAgents" }
const _hoisted_8 = { class: "flex flex-col max-h-64 overflow-auto w-full top-36" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = {
  key: 0,
  class: "py-6 border-0 px-4"
}
const _hoisted_11 = { class: "ml-3 flex items-center gap-x-2" }
const _hoisted_12 = { class: "min-w-[32px] min-h-[32px] flex flex-col max-w-[310px]" }
const _hoisted_13 = { class: "truncate" }
const _hoisted_14 = {
  key: 0,
  class: "truncate"
}
const _hoisted_15 = {
  key: 0,
  class: "flex justify-between items-center px-3 bg-white h-[54px] w-full rounded-b-md border-t border-gray-200"
}
const _hoisted_16 = { class: "flex items-center gap-x-4" }
const _hoisted_17 = { class: "text-base leading-6 font-medium w-fit" }
const _hoisted_18 = {
  key: 0,
  class: "flex flex-wrap mt-2"
}
const _hoisted_19 = { class: "flex items-center gap-x-2" }
const _hoisted_20 = { class: "text-xs" }
const _hoisted_21 = { id: "specificTypeDropdown" }
const _hoisted_22 = { class: "text-lg leading-7 font-medium text-black" }
const _hoisted_23 = { class: "flex flex-col cursor-pointer" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "pt-2 flex flex-col gap-y-4"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-5 font-normal text-gray-500" }, " Create a new email to send randomly to the receivers. More emails will send individually. ", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "New email", -1)
const _hoisted_28 = {
  key: 1,
  class: "flex items-center justify-between"
}
const _hoisted_29 = { class: "text-gray-800" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = {
  key: 1,
  class: "pt-2 flex flex-col gap-y-4"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-5 font-normal text-gray-500" }, " Randomly send an email from the selected list/s to all selected recipients ", -1)
const _hoisted_33 = { class: "w-full flex items-center" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium mr-2" }, "From:", -1)
const _hoisted_35 = { class: "flex gap-x-4 items-center" }
const _hoisted_36 = { class: "flex items-center gap-x-1" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "Randomise", -1)
const _hoisted_38 = { id: "searchOverlayTarget" }
const _hoisted_39 = { class: "flex flex-col max-h-64 overflow-auto w-full top-36" }
const _hoisted_40 = { class: "relative" }
const _hoisted_41 = {
  key: 0,
  class: "py-6 border-0 px-4"
}
const _hoisted_42 = { class: "ml-3 flex flex-col gap-x-2 gap-y-1" }
const _hoisted_43 = { class: "rounded-full items-center flex" }
const _hoisted_44 = { class: "flex justify-start" }
const _hoisted_45 = { class: "text-gray-400 text-xs leading-5 font-normal" }
const _hoisted_46 = {
  key: 0,
  class: "flex justify-between items-center px-3 bg-white h-[54px] w-full rounded-b-md border-t border-gray-200"
}
const _hoisted_47 = { class: "flex items-center gap-x-4" }
const _hoisted_48 = { class: "text-base leading-6 font-medium w-fit" }
const _hoisted_49 = {
  key: 0,
  class: "flex flex-col pt-3"
}
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "rounded-full items-center flex" }
const _hoisted_52 = { class: "flex justify-start" }
const _hoisted_53 = { class: "text-gray-400 text-xs leading-5 font-normal" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("h1", { class: "text-lg font-medium text-gray-900" }, "New Email", -1)

import { computed, onMounted, ref, watch } from "vue"
import {
    CheckIcon,
    InformationCircleIcon,
    MinusSmIcon,
    PlusSmIcon,
    SearchIcon,
    TrashIcon,
} from "@heroicons/vue/outline"
import ArrowDown from "@/components/icons/ArrowDown.vue"
import CreatingEmail from "@/components/profile-details/middle-panel/CreatingEmail.vue"
import GgmsModal from "@/components/GgmsModal.vue"
import GgmsButton from "@/components/GgmsButton.vue"
import GgmsInput from "@/components/GgmsInput.vue"
import GgmsCheckBox from "@/components/GgmsCheckBox.vue"
import GgmsChip from "@/components/GgmsChip.vue"
import GgmsLoading from "@/components/GgmsLoading.vue"
import ContactDropdown from "@/components/profile-details/middle-panel/ContactDropdown.vue"
import ListIcon from "@/components/icons/ListIcon.vue"
import ProfilePicture from "@/components/ProfilePicture.vue"
import { debounce, formatHumanReadableDate, stripHtml } from "@/shared/utils/helpers"
import { SendEmailNodeType, SendEmailToType } from "@/shared/models/workflow"
import { useWorkflowStore } from "@/stores/workflow"
import { useTemplateStore } from "@/stores/template"
import { useTagStore } from "@/stores/tag"
import { useAgentsStore } from "@/stores/agents"
import { useIntegrationStore } from "@/stores/integration"
import { useConfigStore } from "@/stores/config"
import { Template } from "@/shared/models/template"
import { Message } from "@/shared/models/message"
import { Sender } from "@/shared/models/sender"
import { Integration } from "@/shared/models/integration"
import { ToastService } from "@/shared/services/toast"
import { Recipient } from "@/shared/models/recipient"
import GgmsTemplateModal from "@/components/GgmsTemplateModal.vue"
import { GgmsError } from "@/shared/services/client"
import { AgencyDomain } from "@/shared/models/agency"
import { Tag } from "@/shared/models/tag"
import { useAgencyStore } from "@/stores/agency"


export default /*#__PURE__*/_defineComponent({
  __name: 'SendEmailComponent',
  setup(__props) {

const agentStore = useAgentsStore()
const workflowStore = useWorkflowStore()
const templateStore = useTemplateStore()
const tagStore = useTagStore()
const configStore = useConfigStore()
const integrationStore = useIntegrationStore()
const agencyStore = useAgencyStore()

const toastService = new ToastService()

const isTypeModalOpen = ref(false)
const typeMenu = ref()
const searchTerm = ref("")
const data = ref<Template[]>([])
const total = ref(0)
const totalAgents = ref(0)
const isCreatingMessageModalOpen = ref(false)
const searchMenu = ref()
const isSearching = ref(false)
const isAllSelected = ref(false)
const isAllSelectedAgents = ref(false)
const showData = ref(false)
const sendingTypes = ref<boolean[]>([])
const senders = ref<Sender[]>([])
const isLoading = ref(false)
const menu = ref()
const agents = ref<Recipient[]>([])
const showSelectedAgents = ref(false)

const isPreviewOpen = ref(false)
const isOpenCreateTemplateModal = ref(false)
const newTemplate = ref({} as Template)
const isOpenDeleteTemplateModal = ref(false)
const deleteableTemplate = ref({} as Template)
const isViewingFormatted = ref(true)
const isTextBodyModified = ref(false)
const selectedDomains = ref<AgencyDomain[]>([])
const domains = computed(() => agencyStore.agency.agencyDomains || [])
const isDomainsDisabled = ref(false)
const selectedTags = ref<Tag[]>([])
const tags = computed(() => tagStore.tableState.data || [])
const specialVariable = ref("")

const currentMessage = ref()

const integrations = computed(() => configStore.integrations as Integration[])
const cachedTags = computed(() => tagStore.cachedTags)
const selectAllText = computed(() => (isAllSelected.value ? "Deselect all" : `Select all (${total.value})`))
const selectAllTextAgents = computed(() =>
    isAllSelectedAgents.value ? "Deselect all" : `Select all (${totalAgents.value})`
)

const options = [
    { displayName: "Enrolled contacts", value: SendEmailToType.enrolled },
    { displayName: "Associated contact", value: SendEmailToType.associated },
    { displayName: "Specific email", value: SendEmailToType.specificEmail },
    { displayName: "Specific users", value: SendEmailToType.specificUsers },
]

const selectionTypes = [
    { label: "Custom email", value: SendEmailNodeType.custom },
    { label: "Pre-made emails", value: SendEmailNodeType.preMade },
    { label: "Emails containing certain tags", value: SendEmailNodeType.containsTags },
    { label: "Email list", value: SendEmailNodeType.listOfSavedTexts },
]

const selectionTitle = computed(() => {
    if (workflowStore.modelValue.value === SendEmailNodeType.custom) {
        return "Custom email"
    }
    if (workflowStore.modelValue.value === SendEmailNodeType.preMade) {
        return "Pre-made emails"
    }
    if (workflowStore.modelValue.value === SendEmailNodeType.containsTags) {
        return "Emails containing certain tags"
    }
    return "Email list"
})

function toggleTypeMenu(event?: Event) {
    if (isTypeModalOpen.value) {
        typeMenu.value.hide()
        isTypeModalOpen.value = false
    } else {
        typeMenu.value.show(event)
        isTypeModalOpen.value = true
    }
}

async function selectType(type: string) {
    typeMenu.value.hide()
    isTypeModalOpen.value = false
    workflowStore.modelValue.value = type
    clearSelectedData()
    await getTemplates()
    total.value = data.value.length
}

async function getTemplates() {
    templateStore.tableState.templateType = "email"
    templateStore.tableState.search = searchTerm.value
    await templateStore.getTemplates()
    data.value = templateStore.tableState.data
}

function clearSelectedData() {
    templateStore.selectedData = []
}

function openCreateMessageModal() {
    isCreatingMessageModalOpen.value = true
}

function openUpdateModal() {
    currentMessage.value = workflowStore.messagePayload
    openCreateMessageModal()
}

function deleteTextMessage() {
    workflowStore.messagePayload = {} as Message
}

function closeCreateMessageModal() {
    isCreatingMessageModalOpen.value = false
}

function saveEmail() {
    isCreatingMessageModalOpen.value = false
}

function toggleSearchMenu(event?: Event) {
    searchMenu.value.show(event)
}

function isTemplateChecked(template: Template) {
    return !!templateStore.selectedData.find((el) => el._id === template._id)
}

function onClick(template: Template) {
    if (isTemplateChecked(template)) {
        const index = templateStore.selectedData.findIndex((el) => el._id === template._id)
        templateStore.selectedData.splice(index, 1)
        return
    }

    templateStore.selectedData.push(template)
}

function isAgentChecked(agent: Recipient) {
    return !!workflowStore.specificUsers.find((el) => el._id === agent._id)
}

function onClickAgents(agent: Recipient) {
    if (isAgentChecked(agent)) {
        const index = workflowStore.specificUsers.findIndex((el) => el._id === agent._id)
        workflowStore.specificUsers.splice(index, 1)
        return
    }

    workflowStore.specificUsers.push(agent)
}

function isValueChecked(value: string) {
    return !!workflowStore.emailSendingTypes.find((el) => el === value)
}

function onSelectType(value: string) {
    if (isValueChecked(value)) {
        const index = workflowStore.emailSendingTypes.findIndex((el) => el === value)
        workflowStore.emailSendingTypes.splice(index, 1)
        return
    }

    workflowStore.emailSendingTypes.push(value)
}

function deleteTemplate(template: Template) {
    templateStore.selectedData.splice(templateStore.selectedData.indexOf(template), 1)
}

function onSelect() {
    if (isAllSelected.value) {
        clearSelectedData()
    } else {
        templateStore.selectedData = data.value
    }
    isAllSelected.value = !isAllSelected.value
}

function closeSearchMenu() {
    showData.value = true
    searchMenu.value.hide()
}

function closeSearchAgentsMenu() {
    showSelectedAgents.value = true
    menu.value[0].hide()
}

function getSendgridSenderProp(propName: string) {
    return integrationStore.integrationConfig?.versions
        ?.at(-1)
        ?.sectionAnswers?.[1]?.answers?.find((answer) => answer.name === propName)?.textAnswers?.[0]
}
async function convertIntegrationsToSenders() {
    integrations.value
        .filter((integration) => integration.integrationType === "inboxEmail" && integration.isEnabled)
        .forEach((integration) => {
            senders.value.push({
                name: integration?.fromName || "",
                email: integration.fromAddress,
                integrationName: integration.integrationName,
            })
        })

    // add Sendgrid integration to the list of senders if the it's enabled
    const sendgridIntegration = integrations.value.find((integration) => integration.integrationName === "sendgrid")
    if (!sendgridIntegration) {
        return
    }
    await integrationStore.getIntegration(sendgridIntegration._id)

    const sendgridSenderEmail = getSendgridSenderProp("item_5")
    const sendgridSenderName = getSendgridSenderProp("item_6")

    if (!sendgridSenderName || !sendgridSenderEmail) {
        return
    }
    senders.value.push({
        name: sendgridSenderName,
        email: sendgridSenderEmail,
        integrationName: sendgridIntegration.integrationName,
    })
}

function setSelectedSender() {
    if (!senders.value?.length) {
        toastService.addToast({
            message: "No email address found. Please add an email address in your profile settings.",
            type: "warning",
        })
        return
    }

    const selectedIndex = senders.value.findIndex((sender) => sender.email === workflowStore.selectedSender.email)

    const senderIndex = selectedIndex === -1 ? 0 : selectedIndex
    workflowStore.selectedSender = senders.value[senderIndex]
}

async function setIntegrations() {
    await convertIntegrationsToSenders()
    setSelectedSender()
}

function toggleMenu(event?: Event) {
    menu.value[0].show(event)
}

function onSelectAgents() {
    if (isAllSelectedAgents.value) {
        clearSpecificUsers()
    } else {
        workflowStore.specificUsers = agents.value
    }
    isAllSelectedAgents.value = !isAllSelectedAgents.value
}

function removeAgent(agent: Recipient) {
    if (workflowStore.specificUsers.includes(agent)) {
        workflowStore.specificUsers.splice(workflowStore.specificUsers.indexOf(agent), 1)
    }
}

function clearSpecificUsers() {
    workflowStore.specificUsers = []
}

function closePreview() {
    isPreviewOpen.value = false
}

function openPreview() {
    isPreviewOpen.value = true
}

function closeCreateTemplateModal() {
    templateStore.validationError = {} as GgmsError
    newTemplate.value = {} as Template
    isOpenCreateTemplateModal.value = false
    closePreview()
    isTextBodyModified.value = false
    selectedDomains.value = []
    selectedTags.value = []
    specialVariable.value = ""
}

function openCreateTemplateModal(template: Template) {
    newTemplate.value = Object.assign({}, template)
    newTemplate.value.textBody = stripHtml(newTemplate.value.body)
    isTextBodyModified.value = true
    // add domains and tags to selected
    selectedDomains.value = domains.value.filter((domain) => newTemplate.value?.domainId === domain._id)
    isDomainsDisabled.value = true
    const templateTagIds = newTemplate.value?.tags?.map((tag) => tag._id)
    selectedTags.value = tags.value.filter((tag) => templateTagIds?.includes(tag._id))
    specialVariable.value = template?.displayName || ""

    isViewingFormatted.value = true
    isOpenCreateTemplateModal.value = true
}

function openDeleteTemplateModal(template: Template) {
    if (isOpenCreateTemplateModal.value) {
        closeCreateTemplateModal()
    }
    isOpenDeleteTemplateModal.value = true
    deleteableTemplate.value = template
}

function updateSelectedTemplate(template: Template) {
    const index = templateStore.selectedData.findIndex((el) => el._id === template._id)
    templateStore.selectedData.splice(index, 1)
    const updatedTemplate = templateStore.tableState.data.find((newTemplate) => template._id === newTemplate._id)
    templateStore.selectedData.push(updatedTemplate)
}

onMounted(async () => {
    try {
        isLoading.value = true
        if (workflowStore.specificUsers.length) {
            showSelectedAgents.value = true
        }
        if (!configStore.integrations.length) {
            await configStore.getConfig()
        }
        await setIntegrations()
        if (workflowStore.emailSendingTypes.length) {
            workflowStore.emailSendingTypes.forEach((type) => {
                const index = options.findIndex((option) => option.value === type)
                sendingTypes.value[index] = true
            })
        }
        if (templateStore.selectedData.length) {
            showData.value = true
        }
        await getTemplates()
        agents.value = await agentStore.searchAgentsRecipients([], searchTerm.value)
        tagStore.tableState.typeName = "messaging-template"
        await tagStore.getTags()
        totalAgents.value = agents.value?.length
        total.value = data.value.length
    } finally {
        isLoading.value = false
    }
})

watch(
    () => searchTerm.value,
    debounce(async () => {
        isSearching.value = true
        agents.value = await agentStore.searchAgentsRecipients([], searchTerm.value)
        isSearching.value = false
    }, 250)
)

watch(
    () => [
        workflowStore.messagePayload,
        workflowStore.emailSendingTypes,
        templateStore.selectedData,
        workflowStore.specificUsers,
        workflowStore.specificEmail,
        workflowStore.modelValue.event,
        workflowStore.selectedSender,
    ],

    () => {
        if (workflowStore.emailSendingTypes.length > 0) {
            if (
                workflowStore.emailSendingTypes.includes(SendEmailToType.specificEmail) &&
                !workflowStore.specificEmail
            ) {
                workflowStore.areButtonDisabled = true
                return
            }
            if (
                workflowStore.emailSendingTypes.includes(SendEmailToType.specificUsers) &&
                workflowStore.specificUsers.length === 0
            ) {
                workflowStore.areButtonDisabled = true
                return
            }
            if (
                workflowStore.modelValue.value === SendEmailNodeType.preMade &&
                templateStore.selectedData.length === 0
            ) {
                workflowStore.areButtonDisabled = true
                return
            }
            if (
                workflowStore.modelValue.value === SendEmailNodeType.custom &&
                (!workflowStore.messagePayload?.from || !workflowStore.messagePayload?.body)
            ) {
                workflowStore.areButtonDisabled = true
                return
            }
            workflowStore.areButtonDisabled = false
            return
        }
        workflowStore.areButtonDisabled = true
        return
    },
    { deep: true }
)

return (_ctx: any,_cache: any) => {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (option, index) => {
        return _createElementVNode("div", {
          key: option.value,
          class: "flex flex-col",
          tabindex: "0"
        }, [
          _createVNode(GgmsCheckBox, {
            modelValue: sendingTypes.value[index],
            "onUpdate:modelValue": ($event: any) => ((sendingTypes.value[index]) = $event),
            checked: isValueChecked(option.value),
            classes: ['mt-1'],
            centered: false,
            onClick: ($event: any) => (onSelectType(option.value))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(option.displayName), 1)
            ]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "checked", "onClick"]),
          (option.value === _unref(SendEmailToType).specificEmail && sendingTypes.value[index])
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(GgmsInput, {
                  modelValue: _unref(workflowStore).specificEmail,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(workflowStore).specificEmail) = $event)),
                  class: "mt-2"
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (option.value === _unref(SendEmailToType).specificUsers && sendingTypes.value[index])
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(GgmsInput, {
                    modelValue: searchTerm.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchTerm).value = $event)),
                    class: "w-full mt-2",
                    iconStart: _unref(SearchIcon),
                    placeholder: "Search",
                    onInput: toggleMenu,
                    onClick: toggleMenu
                  }, null, 8, ["modelValue", "iconStart"]),
                  _createVNode(_component_OverlayPanel, {
                    ref_for: true,
                    ref_key: "menu",
                    ref: menu,
                    class: "!left-0 ring-1 ring-black ring-opacity-5 shadow-lg rounded-md bg-white mx-6 right-1",
                    appendTo: "#overlaySelectAgents"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          (!agents.value?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, "No results found"))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(agents.value, (element) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: element._id,
                                  class: "flex items-center gap-x-2 px-4 py-3 cursor-pointer border-b border-gray-200 last:border-0 overflow-hidden",
                                  tabindex: "0"
                                }, [
                                  _createVNode(GgmsCheckBox, {
                                    checked: isAgentChecked(element),
                                    onClick: ($event: any) => (onClickAgents(element))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_11, [
                                        (element.type === 'agent')
                                          ? (_openBlock(), _createBlock(ProfilePicture, {
                                              key: 0,
                                              image: element?.profilePicture,
                                              fullName: element?.displayName
                                            }, null, 8, ["image", "fullName"]))
                                          : _createCommentVNode("", true),
                                        (element.type === 'collection')
                                          ? (_openBlock(), _createBlock(ListIcon, { key: 1 }))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_12, [
                                          _createElementVNode("p", _hoisted_13, _toDisplayString(element?.displayName), 1),
                                          (element.type === 'agent')
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(element?.email), 1))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["checked", "onClick"])
                                ]))
                              }), 128)),
                          (isSearching.value)
                            ? (_openBlock(), _createBlock(GgmsLoading, { key: 2 }))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (_unref(workflowStore).specificUsers?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", {
                                class: "bg-gray-300 w-4 h-4 rounded-sm cursor-pointer",
                                onClick: clearSpecificUsers
                              }, [
                                _createVNode(_unref(MinusSmIcon), { class: "w-4 h-4" })
                              ]),
                              _createElementVNode("p", _hoisted_17, [
                                _createTextVNode(_toDisplayString(_unref(workflowStore).specificUsers?.length) + " selected - ", 1),
                                _createElementVNode("span", {
                                  class: "font-medium text-primary-color-600 hover:text-primary-color-500 cursor-pointer",
                                  onClick: onSelectAgents
                                }, _toDisplayString(selectAllTextAgents.value), 1)
                              ])
                            ]),
                            _createVNode(GgmsButton, { onClick: closeSearchAgentsMenu }, {
                              default: _withCtx(() => [
                                _createTextVNode("Done")
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 512)
                ]),
                (showSelectedAgents.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(workflowStore).specificUsers, (agent) => {
                        return (_openBlock(), _createBlock(GgmsChip, {
                          key: agent._id,
                          class: "mb-1 mr-2 w-fit border border-gray-300 rounded-md",
                          "bg-color": "#FFFFFF",
                          onOnRemove: ($event: any) => (removeAgent(agent))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_19, [
                              (agent.type === 'collection')
                                ? (_openBlock(), _createBlock(ListIcon, { key: 0 }))
                                : _createCommentVNode("", true),
                              (agent.type === 'agent')
                                ? (_openBlock(), _createBlock(ProfilePicture, {
                                    key: 1,
                                    image: agent?.profilePicture,
                                    fullName: agent?.displayName
                                  }, null, 8, ["image", "fullName"]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_20, _toDisplayString(agent.displayName), 1)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["onOnRemove"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", {
        class: "flex gap-x-2 cursor-pointer w-fit",
        onClick: toggleTypeMenu
      }, [
        _createElementVNode("p", _hoisted_22, _toDisplayString(selectionTitle.value), 1),
        _createElementVNode("div", null, [
          _withDirectives(_createVNode(ArrowDown, { class: "rotate-180 fill-gray-700" }, null, 512), [
            [_vShow, isTypeModalOpen.value]
          ]),
          _withDirectives(_createVNode(ArrowDown, { class: "fill-gray-700" }, null, 512), [
            [_vShow, !isTypeModalOpen.value]
          ])
        ])
      ]),
      _createVNode(_component_OverlayPanel, {
        ref_key: "typeMenu",
        ref: typeMenu,
        appendTo: "#specificTypeDropdown",
        class: "bg-white rounded-md !left-0 ring-1 ring-black ring-opacity-5 shadow-lg mx-6 right-1 w-64 top-0"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(selectionTypes, (type) => {
              return _createElementVNode("div", {
                key: type.value,
                class: "flex justify-between text-sm leading-5 font-normal p-3 items-center border-b",
                onClick: ($event: any) => (selectType(type.value))
              }, [
                _createElementVNode("div", null, _toDisplayString(type.label), 1),
                (_unref(workflowStore).modelValue.value === type.value)
                  ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                      key: 0,
                      class: "w-4 h-4"
                    }))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_24)
            }), 64))
          ])
        ]),
        _: 1
      }, 512)
    ]),
    (_unref(workflowStore).modelValue.value === _unref(SendEmailNodeType).custom)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _hoisted_26,
          (!_unref(workflowStore).messagePayload?.from)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "flex items-center text-sm leading-5 font-medium text-gray-900 gap-x-1 cursor-pointer",
                onClick: openCreateMessageModal
              }, [
                _createVNode(_unref(PlusSmIcon), { class: "h-5 w-5" }),
                _hoisted_27
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", {
                  class: "py-2 pl-2 flex flex-col gap-y-2 max-w-[350px] cursor-pointer w-full",
                  onClick: openUpdateModal
                }, [
                  _createElementVNode("span", _hoisted_29, "From: " + _toDisplayString(_unref(workflowStore).messagePayload?.from?.email?.emailAddress), 1),
                  _createElementVNode("div", {
                    innerHTML: _unref(workflowStore).messagePayload?.subject,
                    class: "text-sm leading-5 font-normal text-gray-600"
                  }, null, 8, _hoisted_30)
                ]),
                _createVNode(_unref(TrashIcon), {
                  class: "w-5 h-5 cursor-pointer text-gray-900",
                  onClick: deleteTextMessage
                })
              ]))
        ]))
      : _createCommentVNode("", true),
    (_unref(workflowStore).modelValue.value === _unref(SendEmailNodeType).preMade)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createVNode(ContactDropdown, {
              dropdownClass: "max-w-[355px]",
              senderClass: "truncate",
              selectedSender: _unref(workflowStore).selectedSender,
              "onUpdate:selectedSender": _cache[2] || (_cache[2] = ($event: any) => ((_unref(workflowStore).selectedSender) = $event)),
              senders: senders.value,
              type: "email",
              isInSidebar: true
            }, null, 8, ["selectedSender", "senders"])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createVNode(_unref(InformationCircleIcon), { class: "w-5 h-5" })
            ]),
            _createVNode(_component_InputSwitch, {
              modelValue: _unref(workflowStore).modelValue.event,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(workflowStore).modelValue.event) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createVNode(GgmsInput, {
              "input-class": "bg-gray-100 border-0",
              modelValue: searchTerm.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchTerm).value = $event)),
              small: true,
              iconEnd: _unref(SearchIcon),
              placeholder: "Search",
              onInput: toggleSearchMenu,
              onClick: toggleSearchMenu
            }, null, 8, ["modelValue", "iconEnd"]),
            _createVNode(_component_OverlayPanel, {
              ref_key: "searchMenu",
              ref: searchMenu,
              class: "!left-0 ring-1 ring-black ring-opacity-5 shadow-lg rounded-md bg-white mx-6 right-1",
              appendTo: "#searchOverlayTarget"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    (!data.value?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, "No results found"))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(data.value, (template) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: template._id,
                            class: "flex gap-x-2 px-4 top-0 py-3 border-b border-gray-200 last:border-0",
                            tabindex: "0"
                          }, [
                            _createVNode(GgmsCheckBox, {
                              checked: isTemplateChecked(template),
                              classes: ['mt-1'],
                              centered: false,
                              onClick: ($event: any) => (onClick(template))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("div", _hoisted_43, _toDisplayString(template.displayName), 1),
                                  _createElementVNode("div", _hoisted_44, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(template.tags, (tag) => {
                                      return (_openBlock(), _createBlock(GgmsChip, {
                                        key: tag._id,
                                        bgColor: cachedTags.value[tag._id]?.backgroundColor,
                                        textColor: cachedTags.value[tag._id]?.foregroundColor,
                                        isRemovable: false,
                                        class: "h-6"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(tag.displayName), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["bgColor", "textColor"]))
                                    }), 128))
                                  ]),
                                  _createElementVNode("p", _hoisted_45, _toDisplayString(_unref(formatHumanReadableDate)(new Date(template.updatedAt), true)), 1)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["checked", "onClick"])
                          ]))
                        }), 128)),
                    (isSearching.value)
                      ? (_openBlock(), _createBlock(GgmsLoading, { key: 2 }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_unref(templateStore).selectedData?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", {
                          class: "bg-gray-300 w-4 h-4 rounded-sm cursor-pointer",
                          onClick: clearSelectedData
                        }, [
                          _createVNode(_unref(MinusSmIcon), { class: "w-4 h-4" })
                        ]),
                        _createElementVNode("p", _hoisted_48, [
                          _createTextVNode(_toDisplayString(_unref(templateStore).selectedData?.length) + " selected - ", 1),
                          _createElementVNode("span", {
                            class: "font-medium text-primary-color-600 hover:text-primary-color-500 cursor-pointer",
                            onClick: onSelect
                          }, _toDisplayString(selectAllText.value), 1)
                        ])
                      ]),
                      _createVNode(GgmsButton, { onClick: closeSearchMenu }, {
                        default: _withCtx(() => [
                          _createTextVNode("Done")
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 512)
          ]),
          (showData.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templateStore).selectedData, (template) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: template._id,
                    class: "flex justify-between items-center border-b border-gray-200 last:border-0 py-2.5 px-2"
                  }, [
                    _createElementVNode("div", {
                      class: "ml-3 flex flex-col gap-x-2 gap-y-1 cursor-pointer w-full",
                      onClick: _withModifiers(($event: any) => (openCreateTemplateModal(template)), ["prevent","stop"])
                    }, [
                      _createElementVNode("div", _hoisted_51, _toDisplayString(template.displayName), 1),
                      _createElementVNode("div", _hoisted_52, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(template.tags, (tag) => {
                          return (_openBlock(), _createBlock(GgmsChip, {
                            key: tag._id,
                            bgColor: cachedTags.value[tag._id]?.backgroundColor,
                            textColor: cachedTags.value[tag._id]?.foregroundColor,
                            isRemovable: false,
                            class: "h-6"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tag.displayName), 1)
                            ]),
                            _: 2
                          }, 1032, ["bgColor", "textColor"]))
                        }), 128))
                      ]),
                      _createElementVNode("p", _hoisted_53, _toDisplayString(_unref(formatHumanReadableDate)(new Date(template.updatedAt), true)), 1)
                    ], 8, _hoisted_50),
                    _createVNode(_unref(TrashIcon), {
                      class: "x-5 h-5 m-1 cursor-pointer",
                      onClick: ($event: any) => (deleteTemplate(template))
                    }, null, 8, ["onClick"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(GgmsModal, {
      open: isCreatingMessageModalOpen.value,
      bodyClass: "p-0",
      headerClass: "border-b border-gray-200 py-5",
      size: "3xl",
      onCloseModal: closeCreateMessageModal
    }, {
      header: _withCtx(() => [
        _hoisted_54
      ]),
      default: _withCtx(() => [
        _createVNode(CreatingEmail, {
          isWorkflow: true,
          message: currentMessage.value,
          onSaveEmail: saveEmail
        }, null, 8, ["message"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(GgmsTemplateModal, {
      open: isOpenCreateTemplateModal.value,
      isCreateTemplate: false,
      isPreviewOpen: isPreviewOpen.value,
      newTemplate: newTemplate.value,
      isDomainsDisabled: true,
      domains: domains.value,
      selectedDomains: selectedDomains.value,
      tags: tags.value,
      selectedTags: selectedTags.value,
      showDeleteButton: false,
      typeDropdownDisabled: true,
      "onUpdate:selectedTags": _cache[5] || (_cache[5] = (value) => (selectedTags.value = value)),
      "onUpdate:selectedDomains": _cache[6] || (_cache[6] = (value) => (selectedDomains.value = value)),
      onClosePreview: closePreview,
      onOpenPreview: openPreview,
      onCloseModal: closeCreateTemplateModal,
      onOpenDelete: _cache[7] || (_cache[7] = ($event: any) => (openDeleteTemplateModal(newTemplate.value))),
      onSaveTemplate: _cache[8] || (_cache[8] = ($event: any) => (updateSelectedTemplate(newTemplate.value)))
    }, null, 8, ["open", "isPreviewOpen", "newTemplate", "domains", "selectedDomains", "tags", "selectedTags"])
  ], 64))
}
}

})